import React from 'react';

const PositionRiskWidgetBuilder: React.FC = () => {
  return (
    <div className="p-4 text-sm text-neutral-500">
      <p className="font-medium text-neutral-700 mb-2">Position Risk</p>
      <p>
        Displays position sizing, risk exposures, and liquidity metrics for the assigned asset.
        Data is fetched automatically based on the asset&apos;s data UID.
      </p>
      <p className="mt-2 text-xs text-neutral-400">
        System widget — no configuration required.
      </p>
    </div>
  );
};

export default PositionRiskWidgetBuilder;
